import { ComponentType } from 'react';

export const getDisplayName = (c: ComponentType): string =>
  c.displayName || c.name || 'Component';
